import { useRecoilState } from "recoil";
const { valoresState } = require("../atom")

const useValoresState = () => {
    return useRecoilState(valoresState);
};
export default useValoresState;